import React from 'react';
import {Table} from 'semantic-ui-react';
import {NoData} from "../../components/table/no-data";
import Currency from "../../components/formatters/currency";

class SupplierInvoiceTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <Table.Row>
                <Table.Cell>{this.props.data.chargeType || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.quantity || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.factor || <NoData/>}</Table.Cell>
                <Table.Cell>
                {this.props.data.chargeUnit ? (
                    this.props.data.chargeUnit.startsWith("£") ? (
                    <Currency value={this.props.data.chargeRate} />
                    ) : this.props.data.chargeUnit.startsWith("p") ? (
                    `${this.props.data.chargeRate}p`
                    ) : (
                    this.props.data.chargeRate
                    )
                ) : (
                    <NoData />
                )}
                </Table.Cell>
                <Table.Cell>{this.props.data.chargeUnit || <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.netValue ? <Currency value={this.props.data.netValue}/> : <NoData/>}</Table.Cell>

                <Table.Cell>{this.props.data.levyValue ? <Currency value={this.props.data.levyValue}/> : <NoData/>}</Table.Cell>
                <Table.Cell>{this.props.data.grossValue ? <Currency value={this.props.data.grossValue}/> : <NoData/>}</Table.Cell>

            </Table.Row>
        );
    }
}

export default SupplierInvoiceTableRow;